import { render, staticRenderFns } from "./CreateContactField.modal.vue?vue&type=template&id=ee96567e&scoped=true&"
import script from "./CreateContactField.modal.vue?vue&type=script&lang=js&"
export * from "./CreateContactField.modal.vue?vue&type=script&lang=js&"
import style0 from "./CreateContactField.modal.vue?vue&type=style&index=0&id=ee96567e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee96567e",
  null
  
)

export default component.exports